import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var ListStyle = function ListStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    lineColor2 = _getThemeData.lineColor2,
    primary6 = _getThemeData.primary6,
    titleColor1 = _getThemeData.titleColor1;
  var _getThemeData2 = getThemeData(props, 'list'),
    fontSize = _getThemeData2.fontSize,
    lineHeight = _getThemeData2.lineHeight;
  return css([".c7n-list.c7n-list{a{color:", ";}.c7n-list-item.c7n-list-item{border-color:", ";.c7n-list-item-meta{align-items:center;.c7n-list-item-meta-content{.c7n-list-item-meta-title.c7n-list-item-meta-title{a{color:", ";}font-size:", "px;line-height:", "px;}.c7n-list-item-meta-description{font-size:", "px;line-height:", "px;}}}.c7n-list-item-content{color:", ";}}}"], primary6, lineColor2, titleColor1, fontSize, lineHeight, fontSize, lineHeight, titleColor1);
};
export default ListStyle;